// @ts-ignore
import {Link} from "react-router-dom";
import React from "react";
import {Button, Sheet, Stack, Typography} from "@mui/joy";
import {CloudOff} from "@mui/icons-material";
import {useLocation} from "react-router";
function TimeOutPage(): React.ReactElement {
    const location = useLocation();
    return (
        <Sheet>
            <Stack
                height='100vh'
                direction="column"
                spacing={1}
                alignItems={{md: "center", xs: "center"}}
                justifyContent={{lg: "center", xs: "center"}}
                paddingX={5}
            >
                <CloudOff sx={{fontSize: 64}}/>
                <Typography fontWeight='lg' level='h2' textAlign='center'>
                    Oups!
                </Typography>
                <Typography color='primary' fontWeight='lg' level='title-lg' textAlign='center'>
                    Something is wrong
                </Typography>
                <Typography level='body-md' textAlign='center'>
                    Check your internet connection then try again.
                </Typography>
                <br/>
                <Link style={{textDecoration: "none"}} to="/">
                    <Button size='sm' color='neutral' variant="soft">
                        {location.pathname === '/' ? 'Reload' : 'Go Home'}
                    </Button>
                </Link>
            </Stack>
        </Sheet>
    );
}
export default TimeOutPage;
